import React from "react";

import type { NapiV2Purchase } from "@app/types/napi-v2-purchase-types";
import type { CreditType } from "@app/types/napi-v2-request-type";

import type { RefundFormState } from "./cancel-trip";

export const CancelTripContext = React.createContext<{
  purchase: NapiV2Purchase;
  refund_cancellation_state: RefundFormState;
  selected_cancellation_option?: CreditType;
  display_hepstar_banner: boolean;
}>({
  purchase: {} as NapiV2Purchase,
  refund_cancellation_state: undefined,
  selected_cancellation_option: undefined,
  display_hepstar_banner: false
});

export const useCancelTripContext = () => React.useContext(CancelTripContext);
